import React from 'react';

export function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500" />
      <p className="text-amber-200 animate-pulse">Loading...</p>
    </div>
  );
}